import React from 'react';
import { X } from 'lucide-react';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  title: string;
}
export const VideoModal = ({
  isOpen,
  onClose,
  videoId,
  title
}: VideoModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4" data-id="element-312">
      <div className="relative w-full max-w-[90vw] xl:max-w-[1400px] bg-black rounded-xl" data-id="element-313">
        <button onClick={onClose} className="absolute -top-12 right-0 p-2 text-white hover:text-gray-300 transition-colors duration-200 rounded-full hover:bg-white/10" aria-label="Close video" data-id="element-314">
          <X className="w-6 h-6" data-id="element-315" />
        </button>
        <div className="relative pb-[56.25%] h-0" data-id="element-316">
          <iframe src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1`} className="absolute top-0 left-0 w-full h-full rounded-lg" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" title={title} data-id="element-317" />
        </div>
      </div>
    </div>;
};